module.exports = __webpack_public_path__ + "static/preset-image-left-f241d4b44165fe82710c7ad99c998e42.png";